import { Component, Input, ViewChild, ElementRef, ComponentRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ConfigService } from '../../../services/config.service';
import { GeoServices } from '../../../services/geo.service';
import { Http } from '@angular/http';
import { BSModalContext } from 'angular2-modal/plugins/bootstrap/src/bootstrap';
import { ModalComponent, DialogRef } from 'angular2-modal';
import { LoaderDirective } from '../../directives/loader-directive';
import { CustomerTemplateState, CustomerConfig } from '../../models/customer-config';
import { AbstractComponent } from '../../models/abstract-component';
import { ComponentsManagerService } from 'nm-socle-application/app/shared/services/component-manager.service';
import {TemplateInitService} from 'nm-socle-application/app/shared/services/template-init.service';

export class ModalContainerComponentContext extends BSModalContext {
    public templateType:string;
    public states:CustomerTemplateState[] = [];
    public modalSmallPosition:string;
    public showOverlay:boolean = true;

    constructor(fields?: Partial<ModalContainerComponentContext>) {
        super();

        if (fields) {
            Object.assign(this, fields);
        }
    }
}

@Component({
    selector: 'modal-form',
    templateUrl: './modal-container.component.html',
    styleUrls: ['./modal-container.component.scss'],
    changeDetection:ChangeDetectionStrategy.OnPush,
})

export class ModalContainerComponent extends AbstractComponent implements ModalComponent<ModalContainerComponentContext> {
    public context: ModalContainerComponentContext;

    public customerConfig:CustomerConfig;

    @Input() public componentName:string;

    @ViewChild(LoaderDirective) public loaderHost: LoaderDirective;
    protected _compoRef:ComponentRef<Component>;

    public templateType:string;
    @Input() public states:CustomerTemplateState[] = [];
    public modalSmallPosition:string = "center";
    public showOverlay:boolean = true;

    constructor(
        public dialog: DialogRef<ModalContainerComponentContext>,
        protected _configService:ConfigService,
        protected _geoServices:GeoServices,
        protected _http: Http,
        protected elRef: ElementRef,
        private _componentsManagerService: ComponentsManagerService,
        private _templateInitService: TemplateInitService,
        protected _cd:ChangeDetectorRef,
    ) {
        super(_cd);

        this.context = dialog.context;
        this.componentName = this.context.component;
        this.templateType = this.context.templateType;

        if(this.context.modalSmallPosition != undefined) {
            this.modalSmallPosition = this.context.modalSmallPosition;
        }

        this.showOverlay = this.context.showOverlay;
    }

    public ngOnInit() {
        super.ngOnInit();

        this.addSub = this._templateInitService.customerConfig$.subscribe(conf => {
            this.customerConfig = conf;

            this.markForCheck();
        });

        if(this.context.component != undefined) {
            this.componentName = this.context.component;
            this.templateType = this.context.templateType;

            if(this.context.modalSmallPosition != undefined) {
                this.modalSmallPosition = this.context.modalSmallPosition;
            }

            this.showOverlay = this.context.showOverlay;
            this.states = this.context.states;
        }

        this._compoRef = this._componentsManagerService.createComponent(this._compoRef, this.componentName, this.loaderHost);

        if(this._compoRef != undefined) {
            this._compoRef.changeDetectorRef.detectChanges();
            this.markForCheck();

            this._compoRef.instance['states'] = this.states;
            this._compoRef.instance['templateType'] = this.templateType;

            if(this._compoRef.instance['closeEvent'] != undefined) {
                this.addSub = this._compoRef.instance['closeEvent'].subscribe(evt => {
                    this.dialog.close()
                });
            }
        }

        this.markForCheck();
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/shared/components/modal-container/modal-container.component.ts